import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, take, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { IdbClientService } from '../services/idb-client/idb-client.service';
import { RouteEntity } from '@core/router/route.entity';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { SupportState } from '../state/support.state';
import { GetClientDataIdResponse } from '@api/models/ClientSupportApi/Contract/get-client-data-id-response';
import { ErrorResponse } from '@core/error/error-response.model';


@Injectable({
    providedIn: 'root',
})
export class ClientSearchResolverService {
    readonly #idbClientService: IdbClientService = inject(IdbClientService);
    readonly #router: Router = inject(Router);
    readonly #supportState: SupportState = inject(SupportState);

    public resolve(route: ActivatedRouteSnapshot): Observable<GetClientDataIdResponse> | Observable<unknown> {
        const clientId: number = +decodeURIComponent(route.paramMap.get(RoutingQueryParamsName.ClientId));

        return this.#supportState.requestClient(clientId).pipe(
            take(1),
            tap((client: GetClientDataIdResponse) => {
                if (!client) {
                    this.#router.navigate([RouteEntity.Root, RouteEntity.Clients]);
                }

                if (client.clientType !== 8) {
                    this.#idbClientService.idb
                        .store({
                            mobilePhone: client?.mobilePhone,
                            id: clientId,
                            sort: Date.now(),
                        })
                        .subscribe(() => {});
                }

                this.#supportState.setClientId(clientId);
            }),
            catchError((error: ErrorResponse) => {
                console.warn(error);
                this.#router.navigate([RouteEntity.Root, RouteEntity.Clients]);

                return throwError(`error: ${error}`);
            }),
        );
    }
}
